export default {
  name: {
    id: 'rm_metal_palladium_name',
    defaultMessage: 'Palladium',
  },
  smartphoneLabel: {
    id: 'rm_metal_palladium_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_palladium_what_it_does',
    defaultMessage:
      'Palladium appears in tiny quantities on circuit boards and in some connectors, resistors and capacitors. Its resistance to oxidation and corrosion makes it useful for reliable electrical connections.',
  },
  extractionText1: {
    id: 'rm_metal_palladium_extraction_p1',
    defaultMessage:
      'Palladium is one of six platinum-group metals (PGMs), alongside platinum, iridium, osmium, rhodium and ruthenium. Palladium and platinum are the most abundant. Palladium is rarely mined on its own. It is recovered alongside platinum, nickel or copper from underground ores. The ore is crushed into a fine powder and mixed with water so the metal-bearing particles can be separated. The resulting concentrate is heated in a furnace to create a mixture of metals, then chemically refined to separate high-purity palladium from the others.',
  },
  quickFactText: {
    id: 'rm_metal_palladium_quick_fact',
    defaultMessage:
      'Russia and South Africa account for about 77% of global palladium mine production. This concentration leaves global supply exposed to political decisions, power shortages, labour disputes and mine disruptions in just two countries.',
  },
  envSummaryText: {
    id: 'rm_metal_palladium_env_summary',
    defaultMessage:
      'Palladium mining has environmental impacts at every stage, from extraction and waste generation to energy-intensive smelting and refining. Palladium concentrations in ore are often only a few grams per tonne, so large amounts of rock must be crushed and processed. The environmental information below concerns platinum-group metals (PGMs) in general, of which palladium is one, alongside platinum, iridium, osmium, rhodium and ruthenium.',
  },
  envWaterText: {
    id: 'rm_metal_palladium_env_water_text',
    defaultMessage:
      'Producing one kilogram of platinum-group metals in South Africa can use 200,000 to 600,000 litres of water before the metal is concentrated. Up to 73% can be lost through evaporation or seepage from mining-waste storage. In dry seasons, this puts extra pressure on water supplies. In Russia and Canada, sulphur-rich waste can also make mine water acidic, threatening rivers and groundwater.',
  },
  envSoilText: {
    id: 'rm_metal_palladium_env_soil_text',
    defaultMessage:
      'Most platinum-group metals are mined underground, so less soil and rock are removed at the surface than in open-pit mines. But mining still creates large volumes of waste stored above ground. In Russia and Canada, sulphur-rich waste can react with air and water, producing acid that contaminates land and waterways.',
  },
  envBiodiversityText: {
    id: 'rm_metal_palladium_env_biodiversity_text',
    defaultMessage:
      'Underground mines disturb less land than open-pit mines, but shafts, processing plants and mining-waste storage still transform landscapes. South African platinum-group operations use around 8 to 24 m² per kilogram of metal, and some are close to national parks and nature reserves. Dust, noise, water pollution and mine expansion can affect nearby habitats.',
  },
  envClimateText: {
    id: 'rm_metal_palladium_env_climate_text',
    defaultMessage:
      'South Africa produces platinum-group metals using mostly coal-powered electricity. Making just one kilogram releases 25 to 80 tonnes of CO₂, equivalent to driving a petrol car 4 to 13 times around the world.',
  },
  humanSummaryText: {
    id: 'rm_metal_palladium_human_summary',
    defaultMessage:
      'Palladium is produced in large industrial operations rather than small informal mines. In South Africa, thin underground ore layers make extraction highly labour-intensive. The country’s platinum-group metals sector, of which palladium is a part, employed about 175,000 people directly in 2017 and was one of the country’s most valuable mining sectors. However, the industry has a history of fatal accidents and prolonged wage disputes, including a 150-day strike in 2014.',
  },
  humanHealthText: {
    id: 'rm_metal_palladium_human_health_text',
    defaultMessage:
      'Underground dust once caused many cases of silicosis, a permanent lung disease. Better safety measures have made it rare today. Mining is also less deadly than it was in the past: deaths across South Africa fell from more than 700 a year in the late 1980s to fewer than 100. In 2020, 16 of the country’s 60 mining deaths occurred in platinum-group mines.',
  },
  humanLegalText: {
    id: 'rm_metal_palladium_human_legal_text',
    defaultMessage:
      'In 2012, police killed 34 striking miners at the Marikana platinum-group metals mine in South Africa. Human-rights organisations later accused companies that bought from the mine, including carmakers and chemical producers, of failing to take responsibility for abuses in their supply chains. The mine itself was not directly covered by the main responsible-sourcing certification, and industry guidance amounted only to a minimum standard.',
  },
  geoSummaryText: {
    id: 'rm_metal_palladium_geo_summary',
    defaultMessage:
      'Palladium supply depends heavily on Russia and South Africa, which together were estimated to account for about 77% of global mined palladium production in 2024. Palladium belongs to the platinum-group metal (PGM) family. Across this wider group, around 80% of production came from countries with medium to poor governance in 2019.',
  },
  geoDugText: {
    id: 'rm_metal_palladium_geo_dug_text',
    defaultMessage:
      'In 2024, Russia accounted for 39.5% of global palladium production, followed by South Africa (37.9%), Canada (7.9%), Zimbabwe (7.9%) and the United States (4.2%). This leaves the market highly exposed to political or operational disruptions in its two largest producing countries.',
  },
  geoProcessedText: {
    id: 'rm_metal_palladium_geo_processed_text',
    defaultMessage:
      'Palladium is usually processed close to where it is mined. The supply chain often includes concentration, smelting and refining in the main producing countries, particularly Russia and South Africa, either by mining companies or specialist partners. Some palladium entering Europe undergoes further refining in Belgium, Germany, Norway or the United Kingdom.',
  },
  geoLeverageText: {
    id: 'rm_metal_palladium_geo_leverage_text',
    defaultMessage:
      'After Russia invaded Ukraine, some responsible-mining initiatives excluded Russian producers or considered doing so. Norilsk’s membership in the Initiative for Responsible Mining Assurance (IRMA) was suspended. The London Platinum and Palladium Market continued to allow Russian metal to be traded, but sanctions and customer concerns made access to global markets uncertain. Russia and South Africa applied non-automatic export-licensing requirements, while Zimbabwe imposed an export tax.',
  },
  supplySummaryText: {
    id: 'rm_metal_palladium_supply_summary',
    defaultMessage:
      'Supply can broadly keep up with demand, but the system has little spare flexibility. The main risk is disruption: South African mines face rising costs and potential closures. Palladium supply cannot increase quickly because it is produced alongside other metals.',
  },
  supplyReservesText: {
    id: 'rm_metal_palladium_supply_reserves_text',
    defaultMessage:
      'Known reserves of all six platinum-group metals total around 70,000 tonnes, with 89% located in South Africa. Although this figure is not palladium-specific, it does not indicate a medium-term depletion risk for the group at current production rates.',
  },
  supplyDemandText: {
    id: 'rm_metal_palladium_supply_demand_text',
    defaultMessage:
      'Around 85% of palladium demand goes into vehicle catalytic converters. The IEA expects demand to soften as electric vehicles become more common, with EVs accounting for more than 40% of global car sales by 2030 under current policies. Demand will persist in hybrid and combustion-engine vehicles, as well as in industrial applications.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_palladium_recycling_summary',
    defaultMessage:
      'Palladium is one of the more widely recycled metals. Most secondary material comes from vehicle catalytic converters. In electronics, collection, access, sorting and fine-scale mixing can reduce recovery.',
  },
  recyclingInputText: {
    id: 'rm_metal_palladium_recycling_input_text',
    defaultMessage:
      'About 33% of global palladium supply came from recycled sources in 2019. By comparison, the 11% to 14% figure sometimes cited refers to the European end-of-life recycling input rate for all platinum-group metals.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_palladium_recycling_outlook_text',
    defaultMessage:
      'Not fully. More than 95% of palladium can be recovered once scrap reaches a modern refinery. In practice, reported recycling rates are 50% to 60% for catalytic converters and only in the low double digits for electronic components, where tiny parts are difficult to access and sort. Recycling reduces the need for primary mining but cannot replace it entirely.',
  },
  mine0Region: {
    id: 'rm_metal_palladium_mine0_region',
    defaultMessage: 'Norilsk-Talnakh',
  },
  mine1Region: {
    id: 'rm_metal_palladium_mine1_region',
    defaultMessage: 'Bushveld Complex',
  },
  mine2Region: {
    id: 'rm_metal_palladium_mine2_region',
    defaultMessage: 'Stillwater',
  },
} as const
